import React, { useEffect, useState } from "react";
import faqData from "../../Components/FAQLogic/FAQLogic";
import { useLocation } from "react-router-dom";
import { crossIcon, faqBg, plusIcon } from "../../../../../images";
import Testimonial from "../Testimonials/Testimonial";
import { AnimatePresence, motion } from "motion/react"
import SEO from "../../../../SEO/Seo";
import { metaContent } from "../../../../SEO/metaContent";
const FAQSection = () => {
  const location = useLocation();
  const { heading, subheading, items } =
    faqData[location.pathname] || faqData["/"];
  const [openIndex, setOpenIndex] = useState(null);
  const faqPath = location.pathname;
  const isMetaTag = faqPath === "/faq"
  const handleToggle = (index) => {
    setOpenIndex(openIndex === index ? null : index);
  };
  const groupedItems = items.reduce((acc, item) => {
    if (!acc[item.title]) acc[item.title] = [];
    acc[item.title].push(item);
    return acc;
  }, {});

  const titles = Object.keys(groupedItems);

  // Split titles into two columns
  const columnTitles = [[], []];
  titles.forEach((title, index) => {
    columnTitles[index % 2].push(title);
  });

   useEffect(() => {
     // ✅ Select the static container
     const staticContainer = document.querySelector(".static-container");
     if (!staticContainer) return; // safeguard if not found
 
     // 🟢 Save old background before changing
     const oldBackground = staticContainer.style.backgroundImage;
     const oldBgColor = staticContainer.style.backgroundColor;
     const oldBgSize = staticContainer.style.backgroundSize;
     const oldBgRepeat = staticContainer.style.backgroundRepeat;
     const oldBgPosition = staticContainer.style.backgroundPosition;
     const oldBgAttachment = staticContainer.style.backgroundAttachment;
 
     // 🟣 Apply About Us background image
     staticContainer.style.backgroundImage = `url(${faqBg})`;
     staticContainer.style.backgroundSize = "cover";
     staticContainer.style.backgroundRepeat = "no-repeat";
     staticContainer.style.backgroundPosition = "center";
    //  staticContainer.style.backgroundAttachment = "fixed";
     staticContainer.style.transition = "background 0.5s ease-in-out";
 
     // 🔴 Cleanup: restore old background when leaving AboutUs
     return () => {
       staticContainer.style.backgroundImage = oldBackground;
       staticContainer.style.backgroundColor = oldBgColor;
       staticContainer.style.backgroundSize = oldBgSize;
       staticContainer.style.backgroundRepeat = oldBgRepeat;
       staticContainer.style.backgroundPosition = oldBgPosition;
       staticContainer.style.backgroundAttachment = oldBgAttachment;
     };
   }, []);

  return (
    <>
      {/* Meta tags  */}
      {isMetaTag && (
        <SEO {...metaContent.faq} />
      )}

      <div className="faq-section text-start">
        <div className="text-start mb-5">
          <motion.h2 className="hero-heading text-white gradient-heading"
            initial={{ opacity: 0, y: 40 }}
            whileInView={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.8, ease: "easeOut", delay: 0.1 }}
            viewport={{ once: false }}  >{heading}</motion.h2>
          <motion.p className="hero-heading ms-5 text-white gradient-heading"
            initial={{ opacity: 0, y: 40 }}
            whileInView={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.8, ease: "easeOut", delay: 0.1 }}
            viewport={{ once: false }}
          >{subheading}</motion.p>
        </div>
        <div className="mx-3 mx-md-5">
          {[0, 1].map((col) => (
            <div className="" key={col}>
              {columnTitles[col].map((title) => (
                <div
                  className="p-3 mb-3 border-bottom"
                  key={title}
                  onClick={() => handleToggle(title)}
                  style={{ cursor: "pointer" }}
                >
                  <div className="d-flex align-items-center justify-content-between">
                    {/* <div className="d-flex align-items-center"> */}
                    <div className="faq-title">{title}</div>
                    <div className=" me-3">
                      <span className="text-white fw-bold fs-5">
                        {openIndex === title ? <img src={crossIcon} alt="crossIcon" className="img-fluid" /> : <img src={plusIcon} alt="plusIcon" className="img-fluid" />}
                      </span>
                    </div>
                    {/* </div> */}
                  </div>
                  <AnimatePresence>

                    {openIndex === title && (
                      <>
                        <motion.div
                          initial={{ height: 0, opacity: 0 }}
                          animate={{ height: "auto", opacity: 1 }}
                          exit={{ height: 0, opacity: 0 }}
                          transition={{ duration: 0.35, ease: "easeInOut" }}
                          style={{ overflow: "hidden" }}
                          className="mt-3">
                          {groupedItems[title].map((item) => (
                            <div key={item.question} className="mb-3">
                              <div className="faq-question fw-semibold">{item.question}</div>
                              <div className="faq-answer">{item.answer}</div>
                            </div>
                          ))}
                        </motion.div>
                      </>
                    )}
                  </AnimatePresence>

                </div>
              ))}
            </div>
          ))}
        </div>
      </div>
      {faqPath === "/faq" && (
        <Testimonial />
      )}
    </>
  );
};

export default FAQSection;
